// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".frame[data-v-36a5674c]{height:250px;width:280px;text-align:center;border:8px solid red}.display-rect-button[data-v-36a5674c]{position:absolute;top:-20%;margin-left:50px}.display-rect-button[data-v-36a5674c],.rect-ctrl-button[data-v-36a5674c]{width:175px;height:64px!important;padding:0 16px;background:#099 0 0 no-repeat padding-box;opacity:1;font:normal normal 700 24px/32px Segoe UI;letter-spacing:0}", ""]);
// Exports
module.exports = exports;
